<script lang="ts">
  import { api, OfflineError } from '../lib/api'
  import { ripple } from '../lib/ripple'
  import Notice from '../lib/components/Notice.svelte'

  let email = $state('')
  let busy = $state(false)
  let sent = $state(false)
  let error = $state<string | null>(null)

  async function submit(event: SubmitEvent) {
    event.preventDefault()
    if (busy) return
    busy = true
    error = null
    try {
      await api.requestPasswordReset(email.trim().toLowerCase())
      sent = true
    } catch (e) {
      // The API answers 202 for an address with no account, so anything reaching here is a real fault
      // rather than "we don't know you" — which must never be reportable from this form.
      error =
        e instanceof OfflineError
          ? 'Could not reach Bird Journal. Check your connection and try again.'
          : 'Something went wrong. Please try again.'
    } finally {
      busy = false
    }
  }
</script>

{#if sent}
  <Notice tone="ok" live>
    <p>
      If there is a Bird Journal account for <strong>{email.trim()}</strong>, we have sent it a link for
      choosing a new password.
    </p>
    <p class="last">The link works once. If it does not arrive within a few minutes, check your spam folder.</p>
  </Notice>
  <p class="alt"><a href="/sign-in">Back to sign in</a></p>
{:else}
  {#if error}
    <Notice tone="error">{error}</Notice>
  {/if}

  <p>Enter the email address on your account and we will send you a link to choose a new password.</p>

  <form onsubmit={submit} novalidate>
    <div class="field">
      <label class="field-label" for="email">Email address</label>
      <div class="sfield">
        <input
          id="email"
          type="email"
          bind:value={email}
          autocomplete="username"
          inputmode="email"
          spellcheck="false"
          required
        />
      </div>
    </div>

    <button class="btn btn-accent rip submit" use:ripple type="submit" disabled={busy}>
      {busy ? 'Sending…' : 'Send the link'}
    </button>
  </form>

  <p class="alt"><a href="/sign-in">Back to sign in</a></p>
{/if}

<style>
  .submit {
    width: 100%;
    margin-top: var(--space-5);
  }
  .alt {
    margin: var(--space-5) 0 0;
    text-align: center;
    font-size: 0.95rem;
  }
  .last {
    margin-bottom: 0;
  }
</style>
